import React, { useState, useEffect} from 'react';
import Loader from '../../loader';
import useRetrieveProfileInfo from '../../../hooks/UserProfile';
import { UserInfoCol } from '../../user/userInfo';
import BigCard from '../../customBigCard';
import CSS from'./home.module.css';
import VpAdminHome from '../VP/admin';

function Home() {

    const { profileInfo, isLoading, isError } = useRetrieveProfileInfo();

    console.log(profileInfo);

    const [isAdmin, setIsAdmin] = useState(false);

    const [isCustomer, setIsCustomer] = useState(false);

    const [isCustomAdmin, setIsCustomAdmin] = useState(false);

    const isLoggedIn = localStorage.getItem('token') !== null;


    useEffect(() => {
        if(profileInfo && profileInfo.role && profileInfo.role.type === 'admin') {
            setIsAdmin(true);
        }
        else if(profileInfo && profileInfo.role && profileInfo.role.type === 'kjede_admin') {
            setIsCustomAdmin(true);
        }
        else if(profileInfo && profileInfo.role && profileInfo.role.type === 'customer') {
            setIsCustomer(true);
        }
    }, [profileInfo]);

    if(isLoading || !profileInfo ) {
        return <Loader />
    }
    if (isError) {
        return <div>Oida, her gikk noe galt - vennligst prøv igjen!</div>
    }

    const redirectToStore = () => {
        window.location.href="/store";
    }

    const redirectToProducts = () => {
        window.location.href="/profile";
    }

    const redirectToAdmin = () => {
        window.location.href="/admin/home";
    }

    // const redirectToVPadmin = () => {
    //     window.location.href="/VP/admin";
    // }

    if (!isLoggedIn) {
        window.location.href="/";
        return null; 
      }
    

    return(
        <div className="d-flex">
            <div className="row col-12 d-flex justify-content-between">
                <div className="col-9 m-auto col-md-4 mt-5">
                    <UserInfoCol user={profileInfo} />
                </div>
                <div className={`${CSS.cardDeck} col-8`}>
                    {isCustomer && (
                        <div className={CSS.row}>
                            <div className="col-8 m-auto col-md-5 mt-5">
                                <BigCard 
                                    p1="PRODUKTMENY"
                                    p2="TILBUD"
                                    p3="BESTILLING"
                                    p_className="big-card-text" 
                                    buttonTitle="NETTBUTIKK" 
                                    buttonClass="nettbutikk-button text-white my-3 col-10 m-auto py-3" 
                                    cardClass={`${CSS.card} col-12`} 
                                    buttonOnClick = {redirectToStore}
                                />
                            </div>
                            <div className="col-8 m-auto col-md-5 mt-5">
                                <BigCard 
                                    p1="DINE PRODUKTER"
                                    p2="NESTE PLANLAGTE SERVICE"
                                    p3="SERVICEDOKUMENTASJON"
                                    p_className="big-card-text" 
                                    buttonTitle="PRODUKTOVERSIKT" 
                                    buttonClass="produkt-button text-white my-3 col-10 m-auto py-3" 
                                    cardClass={`${CSS.card} col-12`}  
                                    buttonOnClick = {redirectToProducts}
                                />
                            </div>
                     </div>
                    )}
                        {isCustomAdmin && (
                            <div className={CSS.row}>
                                <div className="col-8 m-auto col-md-5 mt-5">
                                    <BigCard 
                                        p1="PRODUKTMENY"
                                        p2="TILBUD"
                                        p3="BESTILLING"
                                        p_className="big-card-text" 
                                        buttonTitle="NETTBUTIKK" 
                                        buttonClass="nettbutikk-button text-white my-3 col-10 m-auto py-3" 
                                        cardClass={`${CSS.card} col-12`} 
                                        buttonOnClick = {redirectToStore}
                                    />
                                </div>
                                <div className="col-8 m-auto col-md-5 mt-5">
                                    <BigCard 
                                        p1="VERKSTEDER"
                                        p2="PRODUKTER"
                                        p3="DOKUMENTASJON"
                                        p_className="big-card-text" 
                                        buttonTitle="KJEDEOVERSIKT" 
                                        buttonClass="admin-button text-white my-3 col-10 m-auto py-3" 
                                        cardClass={`${CSS.card} col-12`}  
                                        buttonOnClick = {redirectToAdmin}
                                    />
                                </div>
                            </div>
                        )}
                        {isAdmin && (
                                <VpAdminHome />
                            )}
                    </div>
                </div>
            </div>
    )
}

export default Home;